<template>
  <el-col>
    <el-dialog
      @closed="expiredPasswordReset"
      :visible.sync="show"
      :close-on-press-escape="false"
      :show-close="false"
      :close-on-click-modal="false"
      width="50%"
    >
      <template #title>
        <div class="dialog-title">
          <span class="pl-5 pt-1">{{ $t("expired_password") }}</span>
        </div>
        <hr />
      </template>

      <div class="expired-password-modal">
        <el-form
          ref="form"
          :model="form"
          label-width="120px"
          :label-position="labelPosition"
        >
          <el-col>
            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
              <el-form-item
                :label="$t('current_password')"
                prop="old_password"
                :error="errors.old_password"
              >
                <el-input
                  v-model="form.old_password"
                  type="password"
                  :show-password="true"
                />
              </el-form-item>
              <el-form-item
                :label="$t('new_password')"
                prop="password"
                :error="errors.password"
              >
                <el-input
                  v-model="form.password"
                  type="password"
                  :show-password="true"
                />
                <p class="password-rules pt-1" style="word-break: break-word">
                  {{ $t("password_rules") }}
                </p>
              </el-form-item>
            </el-col>
            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
              <el-form-item
                :label="$t('confirm_new_password')"
                prop="password_confirmation"
                :error="errors.password_confirmation"
              >
                <el-input
                  v-model="form.password_confirmation"
                  type="password"
                  :show-password="true"
                />
              </el-form-item>
            </el-col>
          </el-col>

          <el-col class="col-p">
            <el-form-item>
              <el-button
                class="btn-primary"
                @click="expiredPasswordReset"
                :loading="saving"
                >{{ saving ? $t("saving") : $t("reset_password") }}</el-button
              >
              <p class="error-message" v-html="errorMessage"></p>
            </el-form-item>
          </el-col>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <hr />
      </span>
    </el-dialog>
  </el-col>
</template>

<script>
import validationMixin from "@/mixins/validationMixin.js";
import { MessageBox } from "element-ui";

export default {
  mixins: [validationMixin],
  data() {
    return {
      saving: false,
      errorMessage: "",
      labelPosition: "top",
      form: {
        password: "",
        password_confirmation: "",
      },
      errors: {},
    };
  },
  computed: {
    passwordExpired() {
      return this.$store.state.passwordExpired;
    },
    show() {
      const isNotPrivacyPolicy = !["/privacy-policy", "/"].includes(
        this.$route.path
      );
      const isLogged = this.$store.getters.isLogged;
      const passwordExpired = this.$store.getters.passwordExpired;
      const showChangePasswordModal =
        this.$store.getters.showChangePasswordModal;

      //console.log("isNotPrivacyPolicy:", isNotPrivacyPolicy);
      //console.log("isLogged:", isLogged);
      //console.log("passwordExpired:", passwordExpired);

      return (
        isNotPrivacyPolicy &&
        isLogged &&
        passwordExpired &&
        showChangePasswordModal == false
      );
    },
  },
  methods: {
    expiredPasswordReset() {
      this.validateForm();
    },
    resizeLabelPosition() {
      if (window.innerWidth <= 768) {
        this.labelPosition = "top";
      }
    },
    showSuccessNotification() {
      const htmlContent = `<div class="text-center">
                            <span class="mdi mdi-check-circle-outline success-icon"></span>
                            <h6 class="pt-3">${this.$t("success")}!</h6>
                            <p>${this.$t("password_updated_successfully")}!</p>
                          </div>`;

      MessageBox.alert(htmlContent, {
        callback: (action) => {},
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        showClose: false,
        closeOnClickModal: true,
        closeOnPressEscape: true,
        center: true,
      });
      setTimeout(() => {
        MessageBox.close();
      }, 3000);
    },
  },
  mounted() {
    this.resizeLabelPosition();
    window.addEventListener("resize", this.resizeLabelPosition);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.resizeLabelPosition);
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/_variables";

.expired-password-modal {
  .col-p {
    padding: 0 10px;
    box-sizing: border-box;
  }
  .password-rules {
    line-height: 14px;
    font-weight: lighter;
    font-style: italic;
    font-size: 13px;
  }

  hr {
    border: 1px solid #b3b3b3;
  }

  h5 {
    font-size: 18px;
    margin-top: 25px;
  }

  .error-message {
    margin-top: 5px;
    line-height: 16px;
  }
}

.input-with-flag .el-input__prefix i {
  font-size: 16px;
  line-height: 1;
  display: flex;
  align-items: center;
}

.col-p {
  padding: 0 10px;
  box-sizing: border-box;
}
.select-wide {
  width: 100%;
}

hr {
  border: 1px solid #b3b3b3;
}

h5 {
  font-size: 18px;
  margin-top: 17px;
}
</style>
